import React, { useEffect, useState, useContext, useRef } from 'react'
import { Table, Button, Popover, Input, Row, Col, Divider, message } from 'antd'
import { useReactToPrint } from 'react-to-print'
import { useHistory } from 'react-router'
import { MoreOutlined } from '@ant-design/icons/lib/icons'
import LoadMoreButton from '../../../../components/LoadMoreButton'
import QuoteListModal from './QuoteListModal'
import PosSrc from '../../PosSrc'
import inventorySrc from '../../../inventory/inventorySrc'
import { Context, useStore } from '../../../../context'
import { CotizacionCartaFactura } from '../quotation/CotizacionCartaFactura'
import Utils from '../../../../utils/Utils'

const { Search } = Input

function QuotationListIndex(props) {
  const [state] = useContext(Context)
  const { hasPermissions } = useStore(state)
  const [loading, setLoading] = useState(false)
  const [nextPage, setNextPage] = useState('')
  const [dataSource, setDataSource] = useState([])
  const [existMoreInfo, setExistMoreInfo] = useState(false)
  const [visible, setVisible] = useState(false)
  const [infoRow, setInfoRow] = useState({})
  const [flag, setFlag] = useState(false)
  const [total, setTotal] = useState(0)
  const [getQuote, setGetQuoteShow] = useState({})
  const [allTurnos, setAllTurnos] = useState(true)

  const history = useHistory()

  useEffect(() => {
    if (props.activeKey === '6') {
      fetchQuoteList(props.store.id)
      props.setProjectData({})
    }
    // eslint-disable-next-line
  }, [props.activeKey])

  // eslint-disable-next-line
  useEffect(() => { handlePrint() }, [flag])

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  },);

  const colorStatus = (text) => {
    switch (text) {
      case 'CONFIRMED':
        return 'var(--tendero-green)'

      case 'REJECTED':
        return 'red'

      default:
        return 'grey'
    }
  }

  const columns = [
    {
      title: 'Cotización',
      dataIndex: 'invoice', // Field that is goint to be rendered
      render: text => <span style={{ textAlign: 'left' }}>{text}</span>,
    },
    {
      title: 'Cliente',
      dataIndex: 'client_id', // Field that is goint to be rendered
      render: text => <span>{`${text}`}</span>,
    },
    {
      title: 'Expiracion',
      dataIndex: 'expiration_date', // Field that is goint to be rendered
      render: text => <span>{text}</span>,
    },
    {
      title: 'Monto',
      dataIndex: 'total', // Field that is goint to be rendered
      render: text => <span>{text}</span>,
    },
    {
      title: 'Status',
      dataIndex: 'status', // Field that is goint to be rendered
      render: text => <span style={{ color: colorStatus(text) }} >{text}</span>,
    },
    {
      align: 'right',
      title: '',
      dataIndex: 'id', // Field that is goint to be rendered
      render: (id, data) => (
        <span>
          {((hasPermissions([81])) && data.status !== 'REJECTED' &&
            <Popover
              placement="left"
              content={
                <div>
                  {hasPermissions([81]) && data.status === 'PENDING' && (
                    <>
                      <span className={'user-options-items'} onClick={() => onEditConfirm(data, '1', id)}>
                        {'Confirmar'}
                      </span>
                      <Divider className={'divider-enterprise-margins'} type={'horizontal'} />
                    </>
                  )}
                  {hasPermissions([83]) && data.status === 'PENDING' && (
                    <>
                      <span className={'user-options-items'} onClick={() => onEditConfirm(data, '5', id)}>
                        {'Editar'}
                      </span>
                      <Divider className={'divider-enterprise-margins'} type={'horizontal'} />
                    </>
                  )}
                  {hasPermissions([84]) && data.status !== 'REJECTED' && data.status !== 'CONFIRMED' && (
                    <>
                      <span className={'user-options-items'} onClick={() => onDelete(data)}>
                        {'Rechazar'}
                      </span>
                      <Divider className={'divider-enterprise-margins'} type={'horizontal'} />
                    </>
                  )}
                  {hasPermissions([81]) && (
                    <>
                      <span className={'user-options-items'} onClick={() => receiptToPrint(1, data)}>
                        {'Imprimir recibo'}
                      </span>
                    </>
                  )}
                </div>
              }
              trigger="click"
            >
              <Button shape={'circle'} className={'enterprise-settings-button'} id={`button-${id}`}>
                <MoreOutlined />
              </Button>
            </Popover>
          )}
        </span>
      ),
    },
  ]

  const fetchQuoteList = async (invoice, filter = '') => {
    setLoading(true)
    const excludeChars = Utils.excludedCharsContent(filter)
    try {
      const getAllClients = await PosSrc.getAllClients()

      let getQuotes = null
      if (!allTurnos) {
        getQuotes = await PosSrc.getQuotesAllTurns(invoice, state.turn.id, filter, excludeChars, 'desc')
      } else {
        getQuotes = await PosSrc.getQuotes(invoice, state.turn.id, filter, excludeChars, 'desc')
      }

      setDataSource(setQuotes(getQuotes.data.data, getAllClients.data))
      setExistMoreInfo(getQuotes.data.next_page_url !== null)
      setNextPage(getQuotes.data.next_page_url)
      setLoading(false)
    } catch (error) {

      console.log(error)
      message.error('Error al cargar las cotizaciones')
      setLoading(false)
    }
  }

  const setQuotes = (quotes, allClients) => {
    if (quotes !== 'Too Many Attempts.') {
      let _quotes = quotes || []
      let quotesList = []
      _quotes.forEach((d, i) => {
        let found = allClients.find(element => element.id === d.client_id);
        let clientName = 'Cliente final'

        if (found) {
          clientName = found.name
        }

        const obj = {
          key: i,
          id: d.id,
          client_id: clientName,
          total: d.total,
          invoice: d.quote_invoice.invoice,
          status: d.status,
          expiration_date: d.expiration_date
        }

        quotesList.push(obj)
      });

      return quotesList
    } else {
      message.error('Se excedió el limte de peticiones, espera y recarga la aplicación')
    }
  }

  const onSearch = searchText => {
    fetchQuoteList(props.store.id, searchText)
  }

  const onDelete = data => {
    if (visible) {
      setLoading(true)
      PosSrc.quoteDelete(infoRow.id)
        .then(res => {
          if (res?.errors && Object.keys(res.errors)?.length > 0) {
            setLoading(false)
            checkErrors(res)
          } else {
            message.success('Se ha eliminado la cotizacion')
            // getCash(res.store_id)
            setLoading(false)
            setVisible(false)
            fetchQuoteList(props.store.id)
          }
        })
        .catch(err => {
          console.log(err)
          message.error('Error al eliminar la cotizacion')
          setLoading(false)
        })

    } else {
      setVisible(true)
      setInfoRow(data)
    }
  }

  const onEditConfirm = async (data, key, id) => {
    document.getElementById(`button-${id}`).click()

    let getQuote = null
    try {
      getQuote = await PosSrc.getQuote(data.id)
    } catch (err) {
      console.log(err)
      history.go(0)
      return false
    }

    const auxDate = new Date(data?.expiration_date)

    let birthday = auxDate
    let today = new Date()
    const x = parseInt((birthday - today))
    const day = (Math.ceil(x / (1000 * 60 * 60 * 24)));

    const products = getQuote.quote_details.map(item => {
      let discount_level = ''
      let discount_amount = 0

      item.presentation.discount_presentation.forEach(p => {
        if (item.discount_id === p.pivot.discount_id) {
          discount_level = p.discount_level

          discount_amount = parseFloat(p.pivot.discount_amount)
        }
      });

      const obj = {
        id: item.id,
        discount_id: item.discount_id,
        discount_amount: parseFloat(discount_amount),
        product: item.presentation.id,
        description: item.presentation.description,
        price: item.price,
        units: parseFloat(item.quantity),
        total: item.sub_total,
        type: item.presentation.presentation_combo_id ? 'COMBO' : 'PRESENTATION',
        discount_level: discount_level
      }

      return obj
    })

    const objQuotation = {
      id: getQuote.id,
      client: getQuote.client,
      products: products,
      quote_id: getQuote.id,
      status: getQuote.status,
      notes: getQuote.notes,
      day: day,
      total: getQuote.total,
      municipality_ticket_code: getQuote.quote_invoice.municipality_ticket_code,
      exonerated_client: getQuote.quote_invoice.exonerated_client
    }

    props.setQuotationData(objQuotation)
    props.setActiveKey(key)
  }

  const checkErrors = res => {
    Object.keys(res.errors).map(key => {
      return message.error(res.errors[key])
    })
  }

  const handlerMoreButton = async () => {
    setExistMoreInfo(false)
    if (existMoreInfo) {
      setLoading(true)

      try {
        const getAllClients = await PosSrc.getAllClients()
        const getNextPage = await PosSrc.getNextPage(nextPage)

        setDataSource(dataSource.concat(setQuotes(getNextPage.data.data, getAllClients.data)))
        setExistMoreInfo(getNextPage.data.next_page_url !== null)
        setNextPage(getNextPage.data.next_page_url)
        setLoading(false)
      } catch (error) {
        console.log(error)
      }

    }
  }


  const receiptToPrint = async (key, quoteShow) => {
    let getQuote = null
    let SkusOptions = null

    try {
      getQuote = await PosSrc.getQuote(quoteShow.id)
      SkusOptions = await inventorySrc.getSkusOptions()
    } catch (err) {
      console.log(err)
      history.go(0)
      return false
    }

    if (getQuote.store.company.country.name === 'Honduras') {
      getQuote.quote_details.forEach(element => {
        SkusOptions.data.forEach(item => {
          if (element.presentation_id === item.presentation_id) {
            element.presentation_id = item.code
          }
        });
      });
    }

    setGetQuoteShow(getQuote)
    setTotal(key)
    setFlag(!flag)
  }

  const returnPrint = (key) => {
    switch (key) {
      case 1:
        return <CotizacionCartaFactura ref={componentRef} getQuote={getQuote} />
      default:
        break;
    }
  }

  return (
    <>
      <Row gutter={16} style={{ display: 'flex', justifyContent: 'space-between' }}>
        <h4 className={'section-space-list-bottom'}>Lista de cotizaciones</h4>
        <Button className="title-tendero new-button" onClick={() => props.newQuote()}>
          {'Nueva cotizacion'}
        </Button>
      </Row>

      <div style={{ display: 'none' }}>{returnPrint(total)}</div>
      <Row gutter={16}>
        <Col xs={19} sm={19} md={19} lg={19}>
          <Search placeholder="Buscar por número de factura" className={'tendero-table-search custom-search'} size={'large'} onSearch={onSearch} />
        </Col>
        {/* {state.auth.role.id < 4 && ( */}
        <Col xs={5} sm={5} md={5} lg={5}>
          <Button className={allTurnos ? 'not-turnos new-deposit' : 'pay-receivable new-deposit'} onClick={() => setAllTurnos(!allTurnos)}>
            {allTurnos ? 'Turno actual' : 'Todos los turnos'}
          </Button>
        </Col>
        {/* )} */}
      </Row>
      <Table
        className={'CustomTableClass'}
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        loading={loading}
        rowKey={(record, index) => index}
      />
      <LoadMoreButton handlerButton={handlerMoreButton} moreInfo={existMoreInfo} />
      <QuoteListModal visible={visible} onDelete={onDelete} visibleStatus={status => setVisible(status)} />
    </>
  )
}

export default QuotationListIndex
